import { render, staticRenderFns } from "./twoColumnIndex.vue?vue&type=template&id=7b91db96"
import script from "./twoColumnIndex.vue?vue&type=script&lang=js"
export * from "./twoColumnIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports